import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserPurchasedPlans from './user-purchased-plans';
import UserPurchasedPlansDetail from './user-purchased-plans-detail';
import UserPurchasedPlansUpdate from './user-purchased-plans-update';
import UserPurchasedPlansDeleteDialog from './user-purchased-plans-delete-dialog';

const UserPurchasedPlansRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UserPurchasedPlans />} />
    <Route path="new" element={<UserPurchasedPlansUpdate />} />
    <Route path=":id">
      <Route index element={<UserPurchasedPlansDetail />} />
      <Route path="edit" element={<UserPurchasedPlansUpdate />} />
      <Route path="delete" element={<UserPurchasedPlansDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UserPurchasedPlansRoutes;
